


















import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import { Col, Row, Image, Tag } from 'vant';
import { DiscussAnswerInfo } from  "@/data/local/discuss";

Vue.use(Col);
Vue.use(Row);
Vue.use(Image);
Vue.use(Tag);

@Component({})
export default class DiscussAnswerItem extends Vue {
  @Prop(Object)
  private itemData: DiscussAnswerInfo | null;

  visitorAvator: string = "http://res.bchun.com/wp-content/uploads/2020/03/visitor-avator.png";
  adminAvator: string = "http://res.bchun.com/wp-content/uploads/2020/03/admin-avator.png";
  
  created() {
    
  }

  mounted() {
    
  }

  get avator(): string {
    if (this.itemData.official === 1) {
      return this.adminAvator;
    }
    
    if (!this.itemData.avatorUrl || this.itemData.avatorUrl === "") {
      return this.visitorAvator;
    }

    return this.itemData.avatorUrl;
  }
}
